$(function()
{
    // Remove the iframe when user clicks the cross in dialog box.
    $('html').on('click', '.icon.icon-times.dialog-close-button', function()
    {
        removeIframe();
    });

    // Switch model filter on the parts search view.
    $('#parts-model-select').change(function()
    {
        $('#parts-search-form').submit();
    });
});

// This function removes the iFrame which is overlaying the document when in full view.
function removeIframe()
{
    var addToBasketIFrame = window.parent.document.getElementById('add-to-basket');
    if (addToBasketIFrame != null)
    {
        window.parent.document.body.style.overflow = ""; //restore scroll that was disabled in amtis-parts-basket.js
        addToBasketIFrame.parentNode.removeChild(addToBasketIFrame);
    }
}

// Loads an error dialog when there is an error with finding the part or parsing the quantity
function loadPartSearchErrorDialog(errorText)
{
    $i.dialog({
        autoOpen: true,
        model: true,
        body: '<div class="validation-message alert alert-danger alert-center">' + errorText + '</div>',
        buttons: {
            'Close': function() {
                this.close();
                removeIframe();
            }
        }
    });
}

// Load the data into the part dialog
// on the parts search page when the user
// click the basket icon button.
function loadPartDialog(elasticId, partNumber, quantityPassedIn, loadingPath, viewToken, documentId, additionalParts)
{
    if (additionalParts === undefined) {
        additionalParts = [];
    }
    var contextPath = window.location.pathname.substring(0, window.location.pathname.indexOf("/",2));
    if(typeof quantityPassedIn === "undefined") {
        quantityPassedIn = 0;
    }
    if (elasticId != null)
    {
        $('.validation-message').hide();
    }
    if(typeof loadingPath === "undefined")
    {
        loadingPath = '<div id="parts-loading-icon"><img id="part-data" alt="Loading..." src="' + contextPath + '/images/loading.gif"/></div>';
    }
    var data = {partElasticId:elasticId, partNumber:partNumber, quantity:quantityPassedIn, viewToken:viewToken, documentId:documentId};
    additionalParts.forEach((part, index) => {
        data[`additionalParts[${index}].partNumber`] = part.partNumber;
        data[`additionalParts[${index}].quantity`] = part.quantity;
    });
    var posting = $.post('parts/parts-search-dialog?nodecorator=true', data);

    var addToBasket = $i.dialog('partDialog', {
        titleKey:  'parts.dialog.title.add',
        body: loadingPath,
        width: '750px',
        buttonKeys: {
            'button.close': function() {
                addToBasket.close();
                this.destroy();
                removeIframe();
            },
            'parts.dialog.button.add': {
                classes: 'add-to-basket',
                callback: function() {
                    $('.add-to-basket').attr("disabled", true);

                    $('.validation-warning').show();

                    posting = $.post('parts/validate-part?nodecorator=true', getData(partNumber));

                    posting.done(function (data) {

                        if (data.success) {
                            addToBasket.close();
                            $('.dialog-box').remove();
                            var itemsInBasket = data.context['lines'];
                            updateBasketCount(itemsInBasket);
                            window.top.postMessage({
                                updateBasket:"true",
                                itemsInBasket: itemsInBasket,
                                successMessage: data.context['successMessage']
                            }, "*");
                            if (window.top.toastr !== undefined) {
                                window.top.toastr.options.escapeHtml=false;
                                window.top.toastr.success('', data.context['successMessage']);
                            }
                            removeIframe();
                        } else {
                            $('.quick-order-error').removeClass('quick-order-error');
                            $('.validation-warning').hide();
                            $('#part-search-dialog-success').hide();
                            //$('#part-quantity').addClass('quick-order-error');
                            for (const [key, value] of Object.entries(data.context)) {
                                $('[data-id=' + key + '-' + value +']').addClass('quick-order-error');
                            }
                            $('.part-dialog-error').html('<div>' + data.reasonForFailure + '</div>' + '<div>' + data.additionalReasonForFailure + '</div>').show();
                            $('.add-to-basket').attr("disabled", false);
                        }
                    });
                }
            }
        }
    });

    $('.add-to-basket').css({'display': 'none'});

    posting.done(function(data)
    {
        if (data.indexOf('part-search-dialog-success') < 0)
        {
            $('.add-to-basket').css({'display': 'none'});
            $('#part-data').replaceWith(data);
            $("#parts-loading-icon").addClass("validation-message alert alert-danger alert-center");
        }
        else
        {
            $('#part-data').replaceWith(data);
            if (data.indexOf('part-dialog-pre-error') < 0)
            {
                $('.add-to-basket').css({'display': 'inline'});
            }
            addToBasket.resize();
            $("#part-type").on('change',function() { $('.part-type').val(($(this).val()))})
            $("#part-quantity").on("input", function() {
                var mainPartQuantity = $(this).val();
                if ($.isNumeric(mainPartQuantity)) {
                    var mainPartQuantityNumber = parseFloat(mainPartQuantity);
                    $(".part-quantity").each(function() {
                        var additionalPartInitialQuantity = parseFloat($(this).data("quantity"));
                        if (!isNaN(additionalPartInitialQuantity)) {
                            $(this).val(mainPartQuantityNumber * additionalPartInitialQuantity);
                        }
                    });
                }
            });
        }
    });

    return false;
}

// Animation for parts being added to basket.
function showSuccess()
{
    $('.validation-message').hide();
    $('#validation-success').show();
    $('.btn-trash').css("display", "block");
}

function getData(partNumber)
{
    var quantity = $('#part-quantity').val();
    var type = $('#part-type').val();
    var supersededPartNumber = $('#superseded-part-number').val();

    var data = {
        partNumber: partNumber,
        quantity: quantity,
        type: type,
        supersededPartNumber: supersededPartNumber
    };

    var additionalParts = getAdditionalParts();
    additionalParts.forEach((part, index) => {
        data[`additionalParts[${index}].partNumber`] = part.partNumber;
        data[`additionalParts[${index}].quantity`] = part.quantity;
        data[`additionalParts[${index}].type`] = part.type;
    });

    return data;
}

function getAdditionalParts()
{
    var parts = [];

    $('table#additional-parts tbody tr.additional-part').each(function () {
        const row = $(this);
        const partNumber = row.find('.part-checkbox').data('part-number');
        const isSelected = row.find('.part-checkbox').is(':checked');
        const quantity = row.find('.part-quantity').val();
        const type = row.find('.part-type').val();

        if (isSelected) {
            parts.push({
                partNumber: partNumber,
                quantity: quantity,
                type: type
            });
        }
    });

    return parts;
}

$('html').on('click', '.additional-parts-part-number, .additional-parts-part-description, .additional-parts-part-icon', function()
{
    $(this).parent().next().find('div.parts-table-div').stop(true, true).slideToggle(300);
});
